import { section } from './rows';
import { formatCoordinates, formatMeasure } from './units';

/** Location rows: the fix itself and its quality (the breadcrumbs table is drawn separately). */
export const locationSections = (view, ctx) => {
	const { t } = ctx;
	const label = (key) => t(`oemDataModal_cerebrumx_location_${key}`);
	const heading = view.heading === undefined ? undefined : t('oemDataModal_degrees', { value: view.heading });
	let gpsFix;
	if (view.gpsInvalid !== undefined) {
		gpsFix = label(view.gpsInvalid ? 'gpsInvalid' : 'gpsValid');
	}

	return [
		section('fix', [
			{
				key: 'coordinates',
				icon: 'place',
				label: label('coordinates'),
				value: formatCoordinates(view.latitude, view.longitude),
			},
			{ key: 'altitude', icon: 'terrain', label: label('altitude'), value: formatMeasure(view.altitude, ctx) },
			{ key: 'heading', icon: 'navigation', label: label('heading'), value: heading },
			{ key: 'gpsFix', icon: 'gps_fixed', label: label('gpsFix'), value: gpsFix },
			{ key: 'gpsError', icon: 'gps_not_fixed', label: label('gpsError'), value: view.gpsError },
		]),
	];
};
